import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=001f8995"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts"
import style0 from "./TermsAndConditions.vue?vue&type=style&index=0&id=001f8995&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports